import { EntitlementType } from '@dreryk/drerykweb-medical-dictionaries-api';

import { FormContextValues } from '@dreryk/react-common';
import { DatePicker } from '@dreryk/react-components';

import { patientEntitlementsTranslationKeys, patientTranslationKeys } from '../../../translations';

export type EntitlementDocumentDateFieldsProps = Pick<FormContextValues, 'register'> & {
   readonly entitlementType: EntitlementType;
};

export const EntitlementDocumentDateFields = (props: EntitlementDocumentDateFieldsProps): JSX.Element => {
   return (
      <>
         <DatePicker
            controller={props.register('validityDateRange.issueDate', { required: true })}
            label={patientEntitlementsTranslationKeys.issueDate}
            placeholder={patientTranslationKeys.datePlaceholder}
            testId={'issueDate'}
            withNavigationArrows
            dayValidators={'dayAfterToday'}
         />
         {props.entitlementType !== 'ZK' && (
            <DatePicker
               controller={props.register('validityDateRange.validityDate')}
               label={patientEntitlementsTranslationKeys.validityDate}
               placeholder={patientTranslationKeys.datePlaceholder}
               testId={'validityDate'}
               withNavigationArrows
               dayValidators={'dayBeforeToday'}
            />
         )}
      </>
   );
};

EntitlementDocumentDateFields.fieldName = 'validityDateRange' as const;
